import React from 'react';
const STEPS = [
  { num:'01', icon:'🔍', title:'Search Any Route', desc:'Enter your origin, destination and dates. We instantly scan 150+ airlines for the lowest available fare.', col:'bg-blue-100 text-blue-700 border-blue-200', acc:'bg-blue-600' },
  { num:'02', icon:'💸', title:'See Real Savings', desc:'Every result shows the regular price vs today\'s deal price so you know exactly how much you\'re saving.', col:'bg-cyan-100 text-cyan-700 border-cyan-200', acc:'bg-cyan-500' },
  { num:'03', icon:'⚡', title:'Book Instantly', desc:'Lock in your deal in under 60 seconds. Get your e-ticket immediately — no waiting, no callbacks.', col:'bg-blue-100 text-blue-700 border-blue-200', acc:'bg-blue-700' },
  { num:'04', icon:'🔔', title:'Set Deal Alerts', desc:'Heading somewhere soon? Set a price alert and we\'ll notify you the moment fares drop for your route.', col:'bg-cyan-100 text-cyan-700 border-cyan-200', acc:'bg-cyan-600' },
];
export default function HowItWorks() {
  return (
    <section className="py-14 sm:py-20 bg-[#0a0f2e]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10 sm:mb-14">
          <span className="inline-block text-xs font-bold text-cyan-400 uppercase tracking-widest bg-cyan-400/10 border border-cyan-400/20 px-4 py-1.5 rounded-full mb-3">How It Works</span>
          <h2 className="text-3xl sm:text-4xl font-black text-white mb-3">From Search to Savings in 4 Steps</h2>
          <p className="text-slate-400 max-w-xl mx-auto text-sm sm:text-base">Our deal-hunting engine does the hard work so you don't have to.</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {STEPS.map(s => (
            <div key={s.num} className="bg-white/5 border border-white/10 rounded-2xl p-6 text-center hover:bg-white/8 transition-all">
              <div className="text-5xl sm:text-6xl font-black text-white/5 mb-2 leading-none">{s.num}</div>
              <div className={'w-14 h-14 rounded-2xl border flex items-center justify-center text-2xl mx-auto mb-4 -mt-6 '+s.col}>{s.icon}</div>
              <h3 className="font-bold text-white mb-2">{s.title}</h3>
              <p className="text-slate-400 text-sm leading-relaxed">{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
